export default __webpack_public_path__ + "static/media/member-mockup.bb3ae891.png";